// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointment_main {
  display: flex;
  justify-content: space-between;
  gap: 80px;
  margin-left: 36px;
  margin-right: 460px;
  padding-top: 20px;
  align-items: flex-start;
  min-height: calc(100vh - 92px);
}`, "",{"version":3,"sources":["webpack://./src/components/AppointmentsComponents/AppointmentsMain/AppointmentsMain.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EAGA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,8BAAA;AADJ","sourcesContent":[".appointment_main {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 80px;\r\n    // margin-left: 138px;\r\n    // margin-right: 557px;\r\n    margin-left: 36px;\r\n    margin-right: 460px;\r\n    padding-top: 20px;\r\n    align-items: flex-start;\r\n    min-height: calc(100vh - 92px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
